import { useNavigation } from "react-router-dom";

/**
 * True while the data router is blocked resolving a navigation to `to`.
 *
 * Routes behind `requireOnboardedLoader` / `RequireBilling` do real work before
 * they render — a token check, `GET /v1/auth/me`, the consent gate, plus the
 * lazy chunk — and React Router holds the *current* page on screen for all of
 * it. The URL does not change and nothing moves, so an un-instrumented CTA
 * reads as a dead button for as long as that takes.
 *
 * Derived from router state rather than a local `useState` flag on purpose: the
 * loader can also `redirect()` (to `/register/profile`, `/consent`, `/login`),
 * and a hand-rolled flag set on click has no idea that happened. This clears
 * itself however the navigation ends.
 *
 * `to` accepts null so callers can pass a target that is not resolvable yet
 * (auth state still hydrating) without branching at the call site.
 */
export function useNavigationPending(to: string | null): boolean {
  const navigation = useNavigation();
  if (to === null) return false;
  return navigation.state === "loading" && navigation.location.pathname === to;
}
